import React, { Component } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";

import { ConsultCarreras} from '../../funciones/ModalidadesFunction';
import { ConsultaSemestres} from '../../funciones/CalifDirFunction';
import { ConsultaProfesSem, ConsultAutoridades } from "../../funciones/CalifDirFunction";
import { EstPorSeccion } from '../../funciones/CalifFunction';
import { AsistenciaEstXls } from '../../funciones/ReportesFunction';

import ListaEstudiantes from '../Estudiantes/ListaEstudiantes';
import ModalReports from '../../components/Reportes/ModalReports';
import AsistenciaEstudiantes from '../../components/Reportes/AsistenciaEstudiantes';

class RepAsistencia extends Component {
    state = {
        valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
        carreras: [{ value: '', label: ' - Cargando Espere - ' }],
        valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
        semestres: [],
        valorSeccion: { value: '', label: '- Selecciona una Sección -', prof: '', profEmail: '' },
        secciones: [],
        preloader: "",
        estudiantes: [],
        textInicial: "",
        gender:"",
        button2: {
            icon: "fa fa-file-excel-o",
            text: "Descargar en xls"
        },
        openW: false,
        aut: ""
    }

    constructor (props) {
        super (props);

        ConsultCarreras ((resp) => {
            this.setState({carreras: resp})
        })
    }

    valorSelectCarrera = (valorCarrera) => {
        this.setState({
            valorCarrera,
            valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
            valorSeccion: { value: '', label: '- Selecciona una Sección -' },
            secciones: [],
        }, () => {
            ConsultaSemestres(valorCarrera.value, (resp) => {
                this.setState({
                    semestres: resp[0],
                })
            })
        });
    }

    valorSelectSemestre = (valorSemestre) => {
        this.setState({
            valorSemestre,
            valorSeccion: { value: '', label: '- Selecciona una Sección -' },
        }, () => {
            ConsultaProfesSem (valorSemestre.value, (resp) => {
                if(resp[0].length > 0) {
                   let Contenido = [];
                    let nombre = (nombre1, nombre2, ape1, ape2) => {
                        if (nombre2 === null) nombre2 = ""
                        if (ape2 === null) ape2 = ""

                        return (`${nombre1} ${nombre2} ${ape1} ${ape2}`)
                    }

                    for(let i in resp[0]){
                        Contenido.push({
                            value: resp[0][i].id, label: `${resp[0][i].carrera_name} [${resp[0][i].materia_name} - ${resp[0][i].nombre}]`,
                            prof: nombre(resp[0][i].nombre_1, resp[0][i].nombre_2, resp[0][i].apellido_1, resp[0][i].apellido_2),
                            profEmail: resp[0][i].email,
                            seccion: `${resp[0][i].carrera_name} ${resp[0][i].materia_name} - ${resp[0][i].nombre}`,
                            semestreNum: resp[0][i].semestre_num,
                            materia: resp[0][i].materia_name,
                            codigo: resp[0][i].codigo,
                            carrera: resp[0][i].carrera_name,
                            seccioName: resp[0][i].nombre,
                            ciProf:  `${resp[0][i].nacionalidad} ${resp[0][i].ci}`,
                        })
                    }

                    this.setState({
                        secciones: Contenido
                    })
                }
            })

            ConsultAutoridades (valorSemestre.value, (resp) => {
                this.setState({aut: resp})
            })
        });
    }

    valorSelectSeccion = (valorSeccion) => {
        this.setState({
            valorSeccion,
            preloader: {
                icon: "fa fa-circle-o-notch fa-spin",
                text: "Buscando estudiantes"
            },
            textInicial: "",
        }, () => {
            EstPorSeccion(valorSeccion.value, (resp) => {
                if (resp[0].length === 0){
                    this.setState({
                        estudiantes: resp[0],
                        preloader: {
                            icon: "",
                            text: ""
                        },
                        textInicial: "La sección seleccionada no tiene estudiantes inscritos",
                    })
                }else{
                    this.setState({
                        estudiantes: resp[0],
                        gender: resp[1],
                        preloader: {
                            icon: "",
                            text: ""
                        },
                        textInicial: "",
                    })
                }
            })
        })
    }

    estudiants = () => {
        let { estudiantes } = this.state;
        if(estudiantes.length === 0) return (
            <tr>
                <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                    No existen estudiantes en esta sección
                </td>
            </tr>
        )

        let num = 1
        let numero = () => { return num ++; }

        let num2 = 1
        let numero2 = () => { return num2 ++; }

        return (
            estudiantes.map(option => (
                <ListaEstudiantes 
                    key={ `est_${numero2()}` }
                    num = {numero()}
                    est = { option }
                />
            ))
        )
    }

    downloadReporte = () => (e) => {
        let { valorSeccion, valorSemestre } = this.state;
        
        if (valorSemestre.value === "") {
            toast.error("Debes seleccionar primero el semestre",{autoClose: 4000});
            return null;
        }
        
        if (valorSeccion.value === "") {
            toast.error("Debes seleccionar primero la sección",{autoClose: 4000});
            return null;
        }
        
        this.setState({
            button2: {
                icon:"fa fa-spinner fa-spin",
                text: "Generando Espere"
            }
        }, () => {
            AsistenciaEstXls(valorSeccion.profEmail, valorSeccion.value, valorSeccion.seccion, (resp) => {
                this.setState({
                    button2: {
                        icon: "fa fa-file-excel-o",
                        text: "Descargar en xls"
                    }
                })             
            })
        })
    }

    printReport = () => {
        let { valorSeccion, valorSemestre } = this.state;
        
        if (valorSemestre.value === "") {
            toast.error("Debes seleccionar primero el semestre",{autoClose: 4000});
            return null;
        }
        
        if (valorSeccion.value === "") {
            toast.error("Debes seleccionar primero la sección",{autoClose: 4000});
            return null;
        }

        this.setState({ openW: true })
    }

    modal = () => {
        let { openW, valorSeccion, estudiantes, aut } = this.state;
        if (openW === false) return null;

        let contenidoModal = () => (
            <AsistenciaEstudiantes
                autoridades = {aut}
                seccion = {valorSeccion}
                estudiantes = {estudiantes}
            />
        )

        return (
            <ModalReports
                reporte={contenidoModal()}
                titulo="Listado de Asistencia de Estudiantes"
                display= "block"
                cerrar = {() => {this.setState({openW:false})}}
            />
        )
    }

    estadistica = () => {
        let { estudiantes, textInicial, valorSeccion, gender, button2 } = this.state;

        let M = gender.masculino;
        let F = gender.femenino;
        let total = estudiantes.length;

        let porcentajeM = (M * 100) / total;
        let porcentajeF = (F * 100) / total;

        if (estudiantes.length === 0) return (
            <div align="center" className="text-muted custom-mt-10">{textInicial}</div>
        )

        const styles = {
            padding: 5, fontSize: 12
        }

        let MainAyuda = (
            <Popover title="Listado de Estudiantes" id="listEst">
                <div align="justify">
                    En este módulo puedes imprimir el listado de asistencia de los estudiantes.
                </div>
                <Row className="custom-mt-10">
                    <Col md={12}>
                        <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                    </Col>
                    <Col md={12} align="justify">
                        Permite generar en formato Pdf el listado de asistencia de los estudiantes para imprimir
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        <button className="btn btn-success btn-xs" style={{borderWidth: 1}}><i className="fa fa-file-excel-o"></i> Descargar Xls</button>
                    </Col>
                    <Col md={12} align="justify">
                        Permite generar en formato Xl el listado de asistencia para su edición
                    </Col>
                </Row>
            </Popover>
        )

        return(
            <React.Fragment>
                <Row>
                    <Col md={7}>
                        <div><span className="text-danger">Profesor:</span> <span className="text-muted">{valorSeccion.prof}</span></div>
                    </Col>
                    <Col md={5} align="right" className="btn-group">
                        <OverlayTrigger trigger="focus" placement="left" overlay={ MainAyuda }>
                            <button className="btn btn-warning" style={{borderWidth:1}} title="Ayuda"><i className="fa fa-question-circle-o"></i>Ayuda</button>
                        </OverlayTrigger>
                        <button className="btn btn-success" style={{borderWidth:1}} title="Descargar el listado en formato xls" onClick = {this.downloadReporte()}><i className={button2.icon}></i> {button2.text}</button>
                        <button className="btn btn-primary" style={{borderWidth:1}} title="Imprimir el Listado de Asistencia" onClick = {this.printReport}><i className="fa fa-print"></i> Imprimir</button>
                    </Col>
                </Row>
                <div className="custom-alert-warning custom-mt-10" style={{fontSize:10}}>Datos estadísticos de la sección <strong>{valorSeccion.seccion}</strong></div>
                <Col md={2}>
                    <div style={{fontSize:10}} className="text-danger">Inscritos:</div>
                    <div style={{fontSize:10}} className="text-muted">({estudiantes.length}) estudiantes</div>
                </Col>
                <Col md={5}>
                    <div style={{fontSize:10}} className="text-danger">Femenino <span className="text-muted">({F}) estudiantes</span></div>

                    <div className="progress">
                        <div className="progress-bar" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeF)}%`, backgroundColor:"#A0555C"}}>
                            {Math.round(porcentajeF)}%
                        </div>
                    </div>
                </Col>
                <Col md={5}>
                    <div style={{fontSize:10}} className="text-danger">Masculino <span className="text-muted">({M}) estudiantes</span></div>

                    <div className="progress">
                        <div className="progress-bar" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeM)}%`, backgroundColor:"#1f2f6e"}}>
                            {Math.round(porcentajeM)}%
                        </div>
                    </div>
                </Col>
                <Row>
                    <Col md={12} className="custom-mt-10">
                        <div className="table-responsive">
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width={30} style={styles}><strong>N°</strong></td>
                                        <td width="20%" style={styles}><strong>Cédula</strong></td>
                                        <td width="80%" colSpan={2} style={styles}><strong>Estudiantes</strong></td>
                                    </tr>
                                    {this.estudiants()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    contenido = () => {
        let { valorCarrera, carreras, valorSemestre, semestres, valorSeccion, secciones, preloader } = this.state;

        return (
            <React.Fragment>
                <div className="custom-alert-info">
                    <Row>
                        <Col md={3}>
                            <Select
                                isSearchable ={true}
                                value={valorCarrera}
                                onChange={this.valorSelectCarrera}
                                options={carreras}
                            />
                            <span className="text-muted" style={{fontSize: 10}}>Carreras</span>
                        </Col>
                        <Col md={3}>
                            <Select
                                isSearchable ={true}
                                value={valorSemestre}
                                onChange={this.valorSelectSemestre}
                                options={semestres}
                            />
                            <span className="text-muted" style={{fontSize: 10}}>Semestres</span>
                        </Col>
                        <Col md={6}>
                            <Select
                                isSearchable ={true}
                                value={valorSeccion}
                                onChange={this.valorSelectSeccion}
                                options={secciones}
                            />
                            <span className="text-muted" style={{fontSize: 10}}>Secciones Disponibles</span>
                        </Col>
                    </Row>
                </div>
                <div align="center" className="text-muted custom-mt-10"><i className={preloader.icon}></i> {preloader.text}</div>
                {this.estadistica()}
            </React.Fragment>
        )
    }

    render() { 
        return (
            <Row>
                <Col md={12}>
                    {this.contenido()}
                </Col>
                {this.modal()}
            </Row>
        );
    }
}
 
export default RepAsistencia;


// WEBPACK FOOTER //
// ./src/views/Reportes/RepAsistencia.jsx